import { memo, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import type { PortalProps } from './types'

const DEFAULT_CONTAINER_ID = 'portal-root'

/**
 * Портал в document.body. Не завязан на конкретный контейнер в index.html —
 * лениво создаёт <div id={containerId}> при маунте (если такого ещё нет)
 * и удаляет его при анмаунте, но только если создал сам и контейнер пуст.
 */
export const Portal = memo(function Portal(props: PortalProps) {
  const { children, containerId = DEFAULT_CONTAINER_ID } = props
  const [container, setContainer] = useState<HTMLElement | null>(null)

  useEffect(() => {
    let el = document.getElementById(containerId)
    let createdBySelf = false

    if (!el) {
      el = document.createElement('div')
      el.id = containerId
      document.body.appendChild(el)
      createdBySelf = true
    }

    setContainer(el)

    return () => {
      if (createdBySelf && el?.childElementCount === 0) {
        el.remove()
      }
    }
  }, [containerId])

  if (!container) return null

  return createPortal(children, container)
})
